import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import pluralize from 'pluralize';
import { InlineSelect, MenuItem } from 'seagull';
import { getClientReminderTimes } from '~/business-logic/notificationSettings';
import { GetCadenceTimesDropdownTID } from './CadenceTimesDropdown.testIds';
export const CadenceTimesDropdown = (param)=>{
    let { times, onChange } = param;
    var _ref;
    const { CadenceTimesDropdownTestIds: testIds } = useMemo(()=>GetCadenceTimesDropdownTID(), []);
    const timesOptions = getClientReminderTimes();
    const value = (_ref = times !== null && times !== void 0 ? times : timesOptions[0]) !== null && _ref !== void 0 ? _ref : 1;
    const triggerLabel = pluralize('time', value, true);
    return /*#__PURE__*/ _jsx(InlineSelect, {
        skin: "primary",
        value: String(value),
        onChange: (event)=>onChange(Number(event.target.value)),
        SelectProps: {
            renderValue: ()=>triggerLabel
        },
        bi: {
            name: 'cadence_times'
        },
        testId: testIds.Trigger(),
        children: timesOptions.map((option)=>/*#__PURE__*/ _jsx(MenuItem, {
                value: String(option),
                testId: testIds.Option(option),
                children: pluralize('time', option, true)
            }, option))
    });
};
